import request from '@/utils/request'
import  qs from 'qs'

export function delHandle(data) {//删除
    return request({
        url: '/employee/del/'+data.id,
        method: 'post',
        data
    })
}

export function detailHandle(data) {//详情
    return request({
        url: '/employee/detail/'+data.id,
        method: 'post',
        data
    })
}

export function createHandle(data) {//创建
    return request({
        url: '/employee/save',
        method: 'post',
        data
    })
}
export function updateHandle(data) {//编辑
    return request({
        url: '/employee/update',
        method: 'post',
        data
    })
}
